import ErrorFilledIcon from './ErrorFilledIcon'

export default ErrorFilledIcon
